/*# sourceMappingURL=slack-alert-channel-details.component-2HG2CCQN.css.map */
